import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Flashcard } from 'src/app/models/flashcard.model';

@Component({
  selector: 'app-flashcard',
  templateUrl: './flashcard.component.html',
  styleUrls: ['./flashcard.component.scss'],
  standalone: false
})
export class FlashcardComponent {

  @Input() flashcard!: Flashcard;
  @Input() side!: 'front' | 'back';
  
  @Input() hideActions: boolean = false;
  @Output() actionsClicked: EventEmitter<Flashcard> = new EventEmitter<Flashcard>();
  @Output() actionClicked: EventEmitter<string> = new EventEmitter<string>();

  todaysDate: Date = new Date();

  constructor() {}

  ngOnInit() {
  }

  handleActionsClick() {
    this.actionsClicked.emit(this.flashcard);
  }

  handleActionClicked(action: string) {
    this.actionClicked.emit(action);
  }
}
